<template>
<main>
  <div class="field">
    <div class="columns">
      <div class="column">
        <field label="Post job as">
          <div class="control is-expanded">
            <div class="select">
              <select v-model="company">
                <option value="">-- choose company --</option>
                <option v-for="c in companies" :key="c.id" :value="c.id">
                {{ c.name }}
                </option>
              </select>
            </div>
          </div>
        </field>
      </div>
      <div class="column">
        <field label="Category">
          <div class="control is-expanded">
            <div class="select">
              <select v-model="category">
                <option value="">-- choose category --</option>
                <option v-for="c in categories" :key="c.id" :value="c.id">
                {{ c.name }}
                </option>
              </select>
            </div>
          </div>
        </field>
      </div>
    </div>
  </div>
  <div>
    <job-type-tags :options="jobTypes" :value="this.formTypeId" @onChangeTag="onChangeType"></job-type-tags>
  </div>
  <div class="field">
    <text-field :label="rewardLabel" v-model="rewardPercentage" />
  </div>

<!--  <div class="field">-->
<!--    <div class="columns">-->
<!--      <div class="column">-->
<!--        <field label="Job type">-->
<!--          <div class="control is-expanded">-->
<!--            <div class="select">-->
<!--              <select v-model="type">-->
<!--                <option value="">&#45;&#45; choose type &#45;&#45;</option>-->
<!--                <option v-for="jt in jobTypes" :key="jt.id" :value="jt.id">-->
<!--                {{ jt.name }}-->
<!--                </option>-->
<!--              </select>-->
<!--            </div>-->
<!--          </div>-->
<!--        </field>-->
<!--      </div>-->
<!--      <div class="column">-->
<!--        <text-field :label="rewardLabel" v-model="rewardPercentage" />-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="field dd">
    <tag-location-field label="Locations" v-model="locations" />
  </div>
  <field label="Remote friendly">
    <div class="control">
      <toggle v-model="remote" :isEditable="true"></toggle>
    </div>
  </field>
  <field label="Salary">
    <div class="control">
      <v-select v-model="salaryType" :options="salaryOptions"></v-select>
    </div>
  </field>
  <div class="field has-addons has-addons-right is-highlighter p-l-20 m-r-0" v-if="displayMax">
    <p class="control">
      <span class="select">
        <select v-model="salaryCurrency">
          <option value="USD">$ USD</option>
          <option value="EURO">€ EURO</option>
          <option value="POUND">£ POUND</option>
        </select>
      </span>
    </p>
    <p class="control is-expanded" v-if="displayMin">
      <input class="input" type="text" placeholder="Salary min" v-model="salaryMin">
    </p>
    <p class="control is-expanded" v-if="displayMax">
      <input class="input" type="text" placeholder="Salary max" v-model="salaryMax">
    </p>
  </div>
  <div class="tag-container">
    <div class="tag-text">
      <p class="p1">Tags * </p> <p class="p2">  <i class="fas fa-circle-exclamation"></i> Minimum of three required</p>
    </div>
    <tags-autocomplete v-model="tags"  placeholder="Type here or click tags" />
  </div>
  <div>
    <suggested-tags v-if="Object.keys(this.jobTags).length > 0" @addTag="addSuggestedTag" @removeTag="removeSuggestedTag" :options="jobTags" :value="this.formTags" @onChangeTag="onChangeType"></suggested-tags>
  </div>
  <h2 class="is-size-4 has-text-weight-bold mb-3">Job Description</h2>
  <field label="Generate using AI">
    <div class="control">
      <toggle v-model="isGenerate" :isEditable="true"></toggle>
    </div>
  </field>
  <field v-if="isGenerate" label="Tone of voice">
    <div class="control">
      <v-select v-model="tone" :options="toneOfVoiceOptions"></v-select>
    </div>
  </field>

  <div class="field">
    <text-field label="Job Title / Role" v-model="role" />
  </div>

  <field v-if="isGenerate" label="Enter prompt here, adding some brief role/company details to increase accuracy">
    <div class="control">
      <editor :initialValue="aiDescription"
              @change="onAiDescriptionChange"
              ref="toastuiEditorForAI"   initialEditType="wysiwyg" :options="editorOptions" :autofocus="false"></editor>
    </div>
  </field>

  <div v-if="isGenerate" class="generate-btn-container">
    <button @click="onGenerateText" :class="loadingClass" class="button is-primary">Generate</button><p v-if="isGenerateLoading">Generating... Your job description will appear below for editing.</p>
  </div>

  <field label="Description">
    <div class="control">
      <editor :initialValue="formDescription"

              @change="onEditorChange"
              ref="toastuiEditor"   initialEditType="wysiwyg" :options="editorOptions" :autofocus="false"></editor>
    </div>
  </field>
  <field label="Status" v-if="showStatusDD">
    <div class="control">
      <v-select v-model="status" :disabled="isCreate" :reduce="status => status.value" :options="statusOptions"></v-select>
    </div>
  </field>
  <alert v-if="showAlert" :type='status.value' :title='alertTitle' :message='alertMessage' />
</main>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import TextField from '@/components/general/text-field'
import Field from '@/components/general/field'
import TagTextField from '@/components/general/tag-text-field'
import TagLocationField from '@/components/general/location-tag-autocomplete'
import TagsAutocomplete from '../../general/tags-autocomplete.vue'
import CurrencyField from '@/components/general/currency-text-field'
import Highlighter from '@/components/general/highlighter'
import Toggle from '@/components/toggle'
import Alert from '@/components/general/alert'
import JobTypeTags from '../../jobs/job-type-tags.vue'
import SuggestedTags from '../../jobs/suggested-tags.vue'
import vSelect from 'vue-select'
import Jobs from '../../../api/jobs'

import '@toast-ui/editor/dist/toastui-editor.css'

import { Editor } from '@toast-ui/vue-editor'

import _ from 'lodash'

export default {
  props: {
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  components: { SuggestedTags, JobTypeTags, TextField, Field, TagTextField, TagLocationField, CurrencyField, vSelect, Highlighter, Toggle, Editor, TagsAutocomplete, Alert },
  computed: {
    ...mapState('adminCompanies', [
      'companies'
    ]),
    ...mapState('domain', ['jobTypes', 'categories', 'jobTypesReward']),
    ...mapState('jobs', ['jobTags']),
    ...mapState('jobForm', {
      formCompany: 'company',
      formRole: 'role',
      formLocations: 'locations',
      formContract: 'contract',
      formSalaryMin: 'salaryMin',
      formSalaryMax: 'salaryMax',
      formDescription: 'description',
      formRemoteAvaialble: 'isRemoteAvailable',
      formRewardPercentage: 'rewardPercentage',
      formSalaryCurrency: 'salaryCurrency',
      formStatus: 'status',
      formCategoryId: 'categoryId',
      formTypeId: 'typeId',
      formTags: 'tags',
      currentJobId: 'currentJobId',
      publishedAt: 'publishedAt'
    }),
    rewardPercentage: {
      get () { return this.formRewardPercentage },
      set (value) { this.setRewardPercentage(value) }
    },
    remote: {
      get () { return this.formRemoteAvaialble },
      set (value) { this.setRemoteAvailable(value) }
    },
    company: {
      get () { return this.formCompany },
      set (value) {
        if (value && this.companies.length > 0) {
          this.companies.forEach((company) => {
            if (company.id === value) {
              if (company.companyJobsBoard && company.companyJobsBoard.length > 0) {
                this.setJobTypesZero()
                this.reward = 0
                this.setRewardPercentage(0)
              }
            }
          })
        } else {
          this.setJobTypesToNormal()
          this.reward = 3
        }

        this.setCompany(value)
      }
    },
    role: {
      get () { return this.formRole },
      set (value) { this.setRole(value) }
    },
    locations: {
      get () { return this.formLocations },
      set (value) { this.setLocations(value) }
    },
    contract: {
      get () { return this.formContract },
      set (value) { this.setContract(value) }
    },
    salaryCurrency: {
      get () { return this.formSalaryCurrency },
      set (value) { this.setSalaryCurrency(value) }
    },
    salaryMin: {
      get () { return this.formSalaryMin },
      set (value) { this.setSalaryMin(value) }
    },
    salaryMax: {
      get () { return this.formSalaryMax },
      set (value) { this.setSalaryMax(value) }
    },
    description: {
      get () { return this.formDescription },
      set (value) { this.setDescription(value) }
    },
    status: {
      get () { return { label: _.upperFirst(this.formStatus), value: this.formStatus } },
      set (v) { this.setStatus(v.value) }
    },
    category: {
      get () { return this.formCategoryId },
      set (v) { this.setCategoryId(v) }
    },
    type: {
      get () { return this.formTypeId },
      set (v) {
        this.onChangeType(v)
      }
    },
    tags: {
      get () { return this.formTags },
      set (value) { this.setTags([...new Set(value)]) }
    },
    statusOptions () {
      return [
        {'label': 'Published', 'value': 'published'},
        {'label': 'Pending', 'value': 'pending'},
        {'label': 'Cancelled', 'value': 'cancelled'},
        {'label': 'Completed', 'value': 'completed'}
      ]
    },
    salaryOptions () {
      return ['Salary range', 'Estimated salary', 'Don\'t display a salary']
    },
    toneOfVoiceOptions () {
      return ['Standard', 'Formal', 'Friendly']
    },
    displayMin () {
      return this.salaryType === 'Salary range'
    },
    displayMax () {
      return this.salaryType === 'Salary range' || this.salaryType === 'Estimated salary'
    },
    alertTitle () {
      switch (this.status.value) {
        case 'pending':
          return 'Once you create the job, your job will be immediately reviewed'
        case 'published':
          return 'Your job is published'
      }
      return null
    },
    rewardLabel () {
      return `Reward percentage (min ${this.reward || 0}%)`
    },
    alertMessage () {
      switch (this.status.value) {
        case 'pending':
          return 'Once approved, it will published to the job board'
        case 'published':
          return `You can now post jobs whenever you need to without review`
      }
    },
    showAlert () {
      if (this.formStatus) {
        return true
      }
      return false
    },
    showStatusDD () {
      return this.currentJobId != null
    },
    loadingClass () {
      return this.isGenerateLoading ? 'is-loading' : ''
    }
  },
  watch: {
    salaryType: function (newValue) {
      if (newValue === 'Don\'t display a salary') {
        this.salaryMin = null
        this.salaryMax = null
      } else if (newValue === 'Estimated salary') {
        this.salaryMin = null
        this.salaryMax = this.salaryMax ? this.salaryMax : ''
      } else {
        this.salaryMin = this.salaryMin ? this.salaryMin : ''
        this.salaryMax = this.salaryMax ? this.salaryMax : ''
      }
    }

  },
  methods: {
    onEditorChange () {
      this.setDescription(this.$refs.toastuiEditor.invoke('getMarkdown'))
    },
    onAiDescriptionChange () {
      this.aiDescription = this.$refs.toastuiEditorForAI.invoke('getMarkdown')
    },
    onGenerateText () {
      this.isGenerateLoading = true
      let chatGptText = ``
      if (this.aiDescription.length > 0) {
        chatGptText = `Write the job description using below details in ${this.tone} tone \n ${this.aiDescription} \n \n \n I want the response in markdown format`
      } else {
        let jobDescriptionArray = []
        if (this.formRole.length > 0) {
          jobDescriptionArray = [...jobDescriptionArray, `Title: ${this.formRole}`]
        }
        if (this.formTags.length > 0) {
          jobDescriptionArray = [...jobDescriptionArray, `Skills required for the job : ${this.formTags.join(',')}`]
        }
        chatGptText = `Write the job description using below details in ${this.tone} tone \n ${jobDescriptionArray.join('\n \n')} \n \n \n I want the response in markdown format`
      }
      try {
        Jobs.generateAiJobDescription(chatGptText).then(res => {
          if (res.choices.length > 0) {
            const description = res.choices[0].message.content
            this.setDescription(description)
            this.$refs.toastuiEditor.invoke('setMarkdown', description)
          }
          this.isGenerateLoading = false
        }).catch(e => {
          alert('Something went wrong please try again')
          this.isGenerateLoading = false
        })
      } catch (e) {
        alert('Something went wrong please try again')
      }
    },
    onChangeType (v) {
      const reward = this.jobTypesReward[v]
      this.reward = reward
      this.setRewardPercentage(reward)
      this.setTypeId(v)
    },
    addSuggestedTag (value) {
      this.setTags([...this.formTags, value])
    },
    removeSuggestedTag (value) {
      const filteredTags = this.formTags.filter(tag => tag !== value)
      this.setTags(filteredTags)
    },
    ...mapActions('adminCompanies', [
      'getAll'
    ]),
    ...mapActions('domain', ['fetchJobTypes', 'fetchCategories']),
    ...mapMutations('domain', ['setJobTypesZero', 'setJobTypesToNormal']),
    ...mapMutations('jobForm', [
      'setCompany',
      'setRole',
      'setLocations',
      'setContract',
      'setSalaryMin',
      'setSalaryMax',
      'setDescription',
      'setRemoteAvailable',
      'setRewardPercentage',
      'setSalaryCurrency',
      'setStatus',
      'setCategoryId',
      'setTypeId',
      'setTags',
      'clear'
    ])
  },
  mounted () {
    this.getAll()
    this.fetchCategories()
    this.$once('hook:beforeDestroy', () => {
      this.clear()
    })
    if (this.formDescription) {
      this.$refs.toastuiEditor.invoke('setMarkdown', this.formDescription)
    }
  },
  beforeUpdate () {
    if (this.salaryMin == null && this.salaryMax == null) {
      this.salaryType = 'Don\'t display a salary'
    } else if (this.salaryMin == null) {
      this.salaryType = 'Estimated salary'
    } else if (this.salaryMin != null && this.salaryMax != null) {
      this.salaryType = 'Salary range'
    }
  },
  data () {
    return {
      editorText: '',
      contentHTML: '',
      contentMARKDOWN: '',
      salaryType: 'Salary range',
      editorOptions: {
        hideModeSwitch: true,
        autofocus: false
      },
      reward: 3,
      isGenerate: false,
      aiDescription: '',
      isGenerateLoading: false,
      tone: 'Standard'
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 100%;

  select {
    width: 100%;
  }

}

.field.is-horizontal {
  margin-bottom: 0;
}

.button.is-static {
  font-weight: normal;
}

.salary-container {
  display: flex;
  margin-top: 16px;
}

.currency-field {
  flex-grow: 1;
}

.spacer {
  margin-left: 3%;
}

.v-select {
  width: 100%;
  // margin-bottom: 0.7rem;
}

/deep/ .v-select li a {
  padding: 0.7rem
}

/deep/ .v-select .dropdown-toggle {
  width: 100%;
  height: 2.5rem;
  margin-bottom: 0.2em;
  border-color: #dbdbdb;
  background: #fff;
  font-size: 14px;
}

/deep/ .v-select .dropdown-toggle:hover {
  border-color: #b5b5b5;
}

/deep/ .v-select .open-indicator::before {
  content: "";
  z-index: 4;
  position: absolute;
  width: 0px;
  height: 0px;
  border-bottom: 6px solid black;
  border-right: 6px solid transparent;
  border-top: 6px solid transparent;
  border-left: 6px solid transparent;
  top: 18%;
  right: 1rem;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: bottom center;
  transition: all .15s cubic-bezier(1,-.115,.975,.855);
  transition-timing-function: cubic-bezier(1,-.115,.975,.855);
}

/deep/ .v-select .open-indicator::after {
  content: "";
  z-index: 4;
  position: absolute;
  width: 0px;
  height: 0px;
  border-top: 6px solid black;
  border-right: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid transparent;
  top: 52%;
  right: 1rem;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: top center;
  transition: all .15s cubic-bezier(1,-.115,.975,.855);
  transition-timing-function: cubic-bezier(1,-.115,.975,.855);
}

/deep/ .v-select.open .open-indicator::before {
  transform: rotate(180deg);
}

/deep/ .v-select.open .open-indicator::after {
  transform: rotate(180deg);
  opacity: 0.0;
}

/deep/ .v-select .clear {
  display: none;
}

.field:not(:last-child) {
  margin-bottom: 20px;
}

.field.dd {
  margin-bottom: 32px;
}

.tag-container{
  margin-bottom: 30px;
}

.tag-text{
  display: flex;
}
.p1{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #080808;
  margin-right: 5px ;
}

.p2{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #979797;
}

.mb-3{
  margin-bottom: 20px;
  margin-top: 30px;
}

.generate-btn-container{
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/jobs/create-job-form.vue